export const REPORT_TYPES_LIST = [
  'Salesforce',
  'ECC',
  'Material',
  'Order Service',
  'Misc',
  'Operations',
] as const
export type ReportType = (typeof REPORT_TYPES_LIST)[number]

export const REPORT_TYPES = {
  SALESFORCE: 'Salesforce',
  ECC: 'ECC',
  MATERIAL: 'Material',
  ORDER_SERVICE: 'Order Service',
  MISC: 'Misc',
  OPERATIONS: 'Operations',
} satisfies Record<string, ReportType>
